import React from 'react'

export default () => (
  <a className="ml1" href="https://www.markdownguide.org/cheat-sheet/">
    Formatting help
  </a>
)
